import React from 'react';

const WhyUs = () => {
  return (
    <div className='md:mt-[164px] mt-12 grid grid-cols-12 gap-6'>
      <div className='lg:col-span-4 md:col-span-6 col-span-12 flex items-center justify-center lg:hidden md:flex'>
        <p className='text-[40px] text-l-primary font-bold text-center'>
          Why Choose <br /> Legal Avenue?
        </p>
      </div>
      <div className='lg:col-span-4 md:col-span-6 col-span-12 bg-l-light-grey p-6 rounded-[16px]'>
        <p className='text-xl font-semibold text-l-primary'>
          No Appointment Headaches
        </p>
        <p className='text-base text-l-primary mt-4'>
          Say goodbye to traffic jams, waiting in muggy offices, and appointment
          chaos. Get connected with top-rated lawyers in an instant, from
          anywhere, anytime.
        </p>
      </div>
      <div className='lg:col-span-4 md:col-span-6 col-span-12  items-center justify-center lg:flex hidden'>
        <p className='text-[40px] text-l-primary font-bold text-center'>
          Why Choose <br /> Legal Avenue?
        </p>
      </div>
      <div className='lg:col-span-4 md:col-span-6 col-span-12 bg-l-light-grey p-6 rounded-[16px]'>
        <p className='text-xl font-semibold text-l-primary'>
          Authentic & Pre-vetted Lawyers
        </p>
        <p className='text-base text-l-primary mt-4'>
          Don’t just settle for any lawyer. Our rigorous vetting process ensures
          you have access to authentic and specialized lawyers who can guide you
          for your specific legal needs.
        </p>
      </div>
      <div className='lg:col-span-4 md:col-span-6 col-span-12 bg-l-light-grey p-6 rounded-[16px]'>
        <p className='text-xl font-semibold text-l-primary'>
          Crystal-clear Communication
        </p>
        <p className='text-base text-l-primary mt-4'>
          Our lawyers speak your language. We explain complex legal concepts in
          an easy way to ensure you’re fully aware and informed before making
          any decisions.
        </p>
      </div>
      <div className='lg:col-span-4 md:col-span-6 col-span-12 bg-l-light-grey p-6 rounded-[16px]'>
        <p className='text-xl font-semibold text-l-primary'>
          Affordable Rates & Flexible Payments
        </p>
        <p className='text-base text-l-primary mt-4'>
          Legal advice shouldn’t break the bank. It should be affordable and
          accessible for everyone. That’s why we offer competitive rates and
          flexible payment options to fit your budget.
        </p>
      </div>
      <div className='lg:col-span-4 md:col-span-6 col-span-12 bg-l-light-grey p-6 rounded-[16px]'>
        <p className='text-xl font-semibold text-l-primary'>
          Information Security
        </p>
        <p className='text-base text-l-primary mt-4'>
          Your security is our top priority. We protect user data, chats, and
          transactions with strong encryption, secure payment gateways, and
          robust user verification.
        </p>
      </div>
      <div className='lg:col-span-4 md:col-span-6 col-span-12 bg-l-light-grey p-6 rounded-[16px]'>
        <p className='text-xl font-semibold text-l-primary'>
          Expertise at Your Fingertips
        </p>
        <p className='text-base text-l-primary mt-4'>
          Whether you’re facing a business dispute, navigating family matters,
          or facing other legal issues, our expert attorneys can confidently
          guide you through your unique legal issues.
        </p>
      </div>
      <div className='lg:col-span-4 md:col-span-6 col-span-12 bg-l-light-grey p-6 rounded-[16px]'>
        <p className='text-xl font-semibold text-l-primary'>
          Client-first Approach
        </p>
        <p className='text-base text-l-primary mt-4'>
          We built Legal Avenue with YOU in mind. From finding specialized
          lawyers, to booking appointments and getting advice, we make the
          entire process smooth and stress-free.
        </p>
      </div>
      <div className='lg:col-span-4 md:col-span-6 col-span-12 bg-l-light-grey p-6 rounded-[16px]'>
        <p className='text-xl font-semibold text-l-primary'>
          Confidence & Peace of Mind
        </p>
        <p className='text-base text-l-primary mt-4'>
          We empower you with reliable legal guidance and seamless support,
          giving you peace of mind and confidence to overcome any legal
          challenges you might face.
        </p>
      </div>
    </div>
  );
};

export default WhyUs;
